<template>
  <div class="salaries-content-group-header">
    <h2 :class="titleClasses" v-html="selectedLink.title" />
    <nav class="salaries-content-group-header__list">
      <a v-for="link in links" :key="link.id" :href="`#${link.id}`" :class="itemClasses(link)">
        → {{ link.label || link.title }}
      </a>
    </nav>
  </div>
</template>

<script>
const LINK_LIST = [
  { title: '2021 Recap', id: 'recap' },
  { title: 'SDR<br>Compensation<br>Guide', label: 'SDR Compensation Guide', id: 'sdr-guide' },
  { title: 'Account Executive<br>Compensation<br>Guide', label: 'AE Compensation Guide', id: 'ae-guide' },
  { title: '2022<br>Remote Work<br>Trends', label: '2022 Remote Work Trends', id: 'trends' },
];

export default {
  name: 'SalariesContentGroupHeader',
  props: {
    groupId: {
      type: String,
      default: '',
    },
  },
  computed: {
    links() {
      return LINK_LIST;
    },
    selectedLink() {
      return this.links.find(link => link.id === this.groupId);
    },
    titleClasses() {
      return ['salaries-content-group-header__title', `salaries-content-group-header__title--${this.selectedLink.id}`];
    },
  },
  methods: {
    itemClasses(link) {
      return [
        'salaries-content-group-header__item',
        link.id === this.selectedLink.id ? `salaries-content-group-header__item--${this.selectedLink.id}` : '',
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-group-header {
  @mixin recap-styles() {
    background: linear-gradient(97.4deg, #204171 0%, #5860a6 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @mixin sdr-guide-styles() {
    color: #161a21;
  }

  @mixin ae-guide-styles() {
    background: linear-gradient(97.4deg, #5b264d 0%, #754e75 100%), linear-gradient(97.4deg, #5b2f4f 0%, #655865 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @mixin trends-styles() {
    background: linear-gradient(86.98deg, #1b447f -13.55%, #5f86d1 110.07%), linear-gradient(0deg, #161a21, #161a21);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  margin-bottom: 88px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;

  @include mq('sm') {
    padding: 0;
    margin-bottom: 32px;
  }

  @include mq('md') {
    padding: 0 40px;
  }

  @include mq('lg') {
    padding: 0 80px;
  }

  &__title {
    font-weight: bold;
    font-size: 56px;
    line-height: 56px;
    letter-spacing: -3px;
    text-transform: uppercase;
    color: #161a21;
    word-break: break-word;

    @include mq('sm') {
      word-break: normal;
    }

    @include mq('md') {
      font-size: 64px;
    }

    &--recap {
      @include recap-styles;
    }

    &--sdr-guide {
      @include sdr-guide-styles;
    }

    &--ae-guide {
      @include ae-guide-styles;
    }

    &--trends {
      @include trends-styles;
    }
  }

  &__list {
    display: none;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;

    @include mq('sm') {
      display: flex;
    }
  }

  &__item {
    font-size: 18px;
    line-height: 32px;
    letter-spacing: -1.45366px;
    text-decoration: none;
    color: #b2bac2;

    @include mq('md') {
      font-size: 24px;
      line-height: 38px;
    }

    &--recap {
      @include recap-styles;
    }

    &--sdr-guide {
      @include sdr-guide-styles;
    }

    &--ae-guide {
      @include ae-guide-styles;
    }

    &--trends {
      @include trends-styles;
    }
  }
}
</style>
